const light = {
  app: {
    actionSheet: {
      primary: {
        closeIcon: 'base.neutrals.white',
        topBg: 'base.blues.blue500',
        imageBorder: 'base.neutrals.gray300',
      },
      warn: {
        closeIcon: 'base.neutrals.gray900',
        topBg: 'base.yellows.yellow500',
        imageBorder: 'base.neutrals.gray300',
      },
      soft: {
        closeIcon: 'base.neutrals.gray900',
        topBg: 'base.blues.blue200',
        imageBorder: 'base.neutrals.gray300',
      },
    },
    googleAd: {
      foreground: 'base.neutrals.gray500',
    },
    icon: 'base.neutrals.gray900',
    alert: {
      success: {
        bg: 'base.greens.green100',
        foreground: 'base.greens.green900',
      },
      warn: {
        bg: 'base.yellows.yellow100',
        foreground: 'base.yellows.yellow900',
      },
    },
    appBanner: {
      foreground: 'base.neutrals.gray900',
    },
    article: {
      offersListBg: 'base.neutrals.gray200',
      authorInfoBorder: 'base.neutrals.gray300',
      border: 'base.neutrals.gray250',
      categoryForeground: 'base.blues.blue700',
      partnerOfferBorder: 'base.neutrals.gray300',
      partnerOfferForeground: 'base.neutrals.gray750',
      partnerOfferForegroundHighlight: 'base.blues.blue500',
      readMoreBg: 'base.neutrals.gray200',
      readMoreIconBg: 'base.neutrals.white',
      readMoreIconForeground: 'base.neutrals.gray900',
      recommendWishlistKeywordBg: 'base.blues.blue500',
      recommendWishlistKeywordForeground: 'base.neutrals.white',
      recommendWishlistKeywordHighlightedForeground: 'base.neutrals.white',
      tableBorder: 'base.neutrals.gray250',
    },
    articles: {
      categoryCarouselBg: 'base.neutrals.gray200',
    },
    articlesHero: {
      categoryBorder: 'base.neutrals.white',
      categoryForeground: 'base.neutrals.white',
      dateForeground: 'base.neutrals.white',
      dotDivisor: 'base.neutrals.white',
      titleForeground: 'base.neutrals.white',
      usernameForeground: 'base.neutrals.white',
    },
    addKeywordWithMaxPrice: {
      backgroundColor: 'base.blues.blue500',
      headingForeground: 'base.neutrals.white',
    },
    blackFridayGlossary: {
      headerForeground: 'base.blues.blue600',
      selectedLetterForeground: 'base.blues.blue900',
      letterItemForeground: 'base.neutrals.gray900',
      pageLinkForeground: 'base.neutrals.gray750',
    },
    carouselCustomDot: {
      backgroundColor: 'base.neutrals.gray500',
      activeBackgroundColor: 'base.neutrals.gray700',
    },
    category: {
      filtersBorder: 'base.neutrals.gray200',
      headingBg: 'base.neutrals.white',
      navActiveItem: 'base.blues.blue700',
      navDeepSubcategoryBorder: 'base.neutrals.gray700',
      wishlistBoxBg: 'base.blues.blue500',
      wishlistBoxForeground: 'base.neutrals.white',
    },
    browserExtensionBanner: {
      background: 'base.blues.blue500',
      buttonBg: 'base.yellows.yellow500',
      buttonForeground: 'base.neutrals.gray750',
      textForeground: 'base.neutrals.white',
    },
    commentSignUpCallToAction: {
      background: 'base.neutrals.gray200',
    },
    commentItem: {
      blockedContentBg: 'base.neutrals.gray200',
      border: 'base.neutrals.gray200',
      fixedBg: 'base.yellows.yellow100',
      fixedForeground: 'base.neutrals.gray800',
      foreground: 'base.neutrals.gray750',
    },
    cookiesPage: {
      headerBackgroundColor: 'base.blues.blue500',
      headerTitleColor: 'base.neutrals.white',
      dividerBg: 'base.neutrals.gray500',
    },
    couponsListItem: {
      titleForeground: 'base.blues.blue800',
      storeNameForeground: 'base.neutrals.gray700',
      discountForeground: 'base.blues.blue800',
      border: 'base.neutrals.gray300',
      finishedCouponDiscountForeground: 'base.neutrals.gray500',
      finishedStoreNameForeground: 'base.neutrals.gray700',
      finishedTitleForeground: 'base.neutrals.gray700',
      verifiedIconColor: 'base.greens.green500',
    },
    couponModal: {
      browserExtensionBlockBg: 'base.blues.blue100',
      browserExtensionBlockBorder: 'base.blues.blue200',
      browserExtensionBlockForeground: 'base.blues.blue700',
      browserExtensionBlockButtonBorder: 'base.neutrals.gray300',
    },
    couponSidebar: {
      border: 'base.neutrals.gray200',
      discountForeground: 'base.blues.blue800',
      imageBorder: 'base.neutrals.gray300',
    },
    couponsPopularStores: {
      carouselDot: 'base.neutrals.gray500',
      carouselDotActive: 'base.neutrals.gray700',
    },
    divider: {
      bg: 'base.neutrals.gray200',
    },
    text: {
      lightForeground: 'base.neutrals.gray200',
      invertedForeground: 'base.neutrals.gray200',
    },
    downloadApp: {
      text: 'base.neutrals.gray750',
    },
    drawer: {
      background: 'base.neutrals.white',
      border: 'base.neutrals.gray300',
      headerForegroundLogged: 'base.neutrals.white',
      headerLoggedBg: 'base.blues.blue500',
      overlayBg: 'base.neutrals.gray800',
      overlayOpacity: '0.8',
    },
    dropdown: {
      border: 'base.neutrals.gray250',
      foreground: 'base.neutrals.gray800',
      innerBg: 'base.neutrals.white',
      itemBg: 'base.neutrals.gray250',
      itemBgAlt: 'base.neutrals.gray300',
      itemHover: 'base.neutrals.gray200',
      overlay: 'base.neutrals.gray900',
      overlayOpacity: '0.25',
    },
    extensionBanner: {
      background: 'base.yellows.yellow500',
    },
    featuredArticles: {
      border: 'base.neutrals.gray200',
    },
    filterOffersByCategoriesModal: {
      border: 'base.neutrals.gray200',
    },
    footer: {
      dividerBg: 'base.neutrals.gray200',
    },
    homePage: {
      offerCardBorderColor: 'base.neutrals.gray250',
    },
    howPromobitWorks: {
      iconBg: 'base.blues.blue500',
      borderTopBg: 'base.blues.blue500',
    },
    suggestNewOffer: {
      border: 'base.neutrals.gray500',
      collapseBg: 'base.neutrals.gray200',
      imageCarouselBorder: 'base.neutrals.gray250',
      photoFallbackBg: 'base.blues.blue100',
      photoFallbackIconColor: 'base.blues.blue300',
      selectedImageBorder: 'base.neutrals.gray200',
      selectedImageCarouselBorder: 'base.greens.green500',
    },
    stepper: {
      completed: {
        foreground: 'base.greens.green800',
        iconColor: 'base.greens.green500',
        iconForeground: null,
        wrapperBackground: 'base.greens.green100',
        wrapperBorderColor: null,
      },
      current: {
        foreground: 'base.neutrals.gray800',
        iconColor: 'base.neutrals.gray800',
        iconForeground: 'base.neutrals.white',
        wrapperBackground: null,
        wrapperBorderColor: 'base.neutrals.gray250',
      },
      not_started: {
        foreground: 'base.neutrals.gray500',
        iconColor: 'base.neutrals.gray300',
        iconForeground: 'base.neutrals.white',
        wrapperBackground: null,
        wrapperBorderColor: 'base.neutrals.gray250',
      },
    },
    landing: {
      dividerBg: 'base.neutrals.gray200',
      headingBackground: 'base.blues.blue500',
      foreground: 'base.neutrals.white',
      partnerOffer: {
        bg: 'base.blues.blue100',
        borderColor: 'base.blues.blue500',
        foreground: 'base.blues.blue700',
      },
    },
    lgpdDialogBox: {
      border: 'base.neutrals.gray200',
    },
    mention: {
      foreground: 'base.blues.blue700',
    },
    mentionSuggestions: {
      background: 'base.neutrals.gray200',
      backgroundHover: 'base.neutrals.gray250',
      border: 'base.neutrals.gray250',
      divider: 'base.neutrals.gray250',
      foreground: 'base.neutrals.gray800',
      itemHover: 'base.neutrals.gray300',
    },
    messages: {
      foreground: 'base.neutrals.gray900',
      returnBackground: 'base.neutrals.gray200',
      dividerForeground: 'base.neutrals.gray500',
      feedbackAvatarBg: 'base.neutrals.white',
      feedbackAvatarForeground: 'base.neutrals.gray700',
    },
    messageTypes: {
      foreground: 'base.neutrals.gray900',
      footerForeground: 'base.neutrals.gray900',
      review: {
        text: 'base.neutrals.gray800',
      },
      approvedOfferMessage: {
        bg: 'base.yellows.yellow100',
        border: 'base.neutrals.gray250',
        gamificationForeground: 'base.blues.blue600',
      },
      blockedItemMessage: {
        bg: 'base.blues.blue100',
        iconBg: 'base.neutrals.white',
        iconBorder: 'base.blues.blue200',
        couponTitle: 'base.blues.blue900',
      },
      feedbackMessage: {
        titleForeground: 'base.blues.blue700',
      },
      offerReviewRating: {
        border: 'base.blues.blue500',
      },
      genericTypes: {
        sended: {
          bubbleBg: 'base.blues.blue100',
          bubbleBorder: 'base.blues.blue300',
          dateForeground: 'base.neutrals.gray750',
          foreground: 'base.neutrals.gray900',
        },
        received: {
          bubbleBg: 'base.neutrals.white',
          bubbleBorder: 'base.neutrals.gray250',
          dateForeground: 'base.neutrals.gray750',
          foreground: 'base.neutrals.gray900',
        },
      },
    },
    conversationsList: {
      types: {
        default: {
          bg: null,
          border: 'base.neutrals.gray250',
          iconForeground: 'base.neutrals.gray500',
        },
        selected: {
          bg: 'base.blues.blue100',
          border: 'base.neutrals.gray250',
          iconForeground: 'base.neutrals.gray500',
        },
      },
      divider: 'base.neutrals.gray250',
    },
    notification: {
      bg: 'base.neutrals.white',
      border: 'base.neutrals.gray300',
      boxBg: 'base.neutrals.gray250',
      readStatusPointerBg: 'base.blues.blue500',
      textForeground: 'base.neutrals.gray800',
    },
    offer: {
      border: 'base.blues.blue500',
      dividerBg: 'base.neutrals.gray200',
      firstOfferBg: 'base.yellows.yellow100',
      firstOfferForeground: 'base.neutrals.white',
      imageBg: 'base.neutrals.white',
    },
    offerPagesTabNav: {
      bg: 'base.neutrals.white',
      activeIconForeground: 'base.blues.blue500',
    },
    offerRelatedItems: {
      border: 'base.neutrals.gray200',
    },
    promonews: {
      bg: 'base.blues.blue700',
      foreground: 'base.neutrals.white',
    },
    rating: {
      border: 'base.neutrals.gray200',
      filledRatingStar: 'base.yellows.yellow500',
    },
    reviewItem: {
      background: 'base.blues.blue100',
      border: 'base.neutrals.gray250',
      headerBg: 'base.blues.blue500',
      headerForeground: 'base.neutrals.white',
    },
    sidebarLink: {
      foreground: 'base.neutrals.gray400',
    },
    socialMedia: {
      bg: 'base.neutrals.gray250',
      foreground: 'base.neutrals.gray800',
    },
    storeInfos: {
      linkForeground: 'base.blues.blue700',
    },
    storesCarousel: {
      itemWrapperBg: 'base.neutrals.white',
    },
    storesDropdown: {
      bg: 'base.neutrals.white',
      border: 'base.neutrals.gray250',
      cardBorder: 'base.neutrals.gray200',
      foreground: 'base.neutrals.gray700',
    },
    storesWithFeaturedOffers: {
      storeNameForeground: 'base.blues.blue800',
      icon: 'base.neutrals.gray800',
      border: 'base.neutrals.gray200',
    },
    suggestNewItem: {
      headingBg: 'base.blues.blue100',
    },
    suggestNewThread: {
      labelForeground: 'base.neutrals.gray800',
      text: 'base.neutrals.gray500',
    },
    searchInStoresCallToAction: {
      border: 'base.blues.blue500',
      icon: 'base.blues.blue500',
      storeBorder: 'base.neutrals.gray300',
    },
    searchWithoutResults: {
      storeItemBg: 'base.neutrals.gray200',
      icon: 'base.blues.blue500',
    },
    tag: {
      uniqueForeground: 'base.greens.green500',
    },
    timeline: {
      offerCard: {
        border: 'base.neutrals.gray200',
        commentCountForeground: 'base.neutrals.gray700',
        commentIconForeground: 'base.neutrals.gray700',
        domainBackground: 'base.neutrals.white',
        domainForeground: 'base.neutrals.gray700',
        titleForeground: 'base.neutrals.gray700',
      },
    },
    toast: {
      action: {
        bg: 'base.neutrals.gray800',
        border: 'base.neutrals.white',
        foreground: 'base.neutrals.white',
        linkForeground: 'base.blues.blue300',
      },
      primary: {
        bg: 'base.blues.blue700',
        border: 'base.neutrals.white',
        foreground: 'base.neutrals.white',
        linkForeground: 'base.neutrals.white',
      },
      success: {
        bg: 'base.greens.green700',
        border: 'base.neutrals.white',
        foreground: 'base.neutrals.white',
        linkForeground: 'base.neutrals.white',
      },
      danger: {
        bg: 'base.reds.red500',
        border: 'base.neutrals.white',
        foreground: 'base.neutrals.white',
        linkForeground: 'base.neutrals.white',
      },
    },
    shareCampaignLoginModal: {
      slideshowBg: 'base.blues.blue100',
      slideshowForeground: 'base.blues.blue900',
    },
    storeInfo: {
      linkForeground: 'base.blues.blue700',
      border: 'base.neutrals.gray200',
      checkedForeground: 'base.greens.green500',
      countForeground: 'base.blues.blue500',
      helpSignIcon: 'base.neutrals.gray500',
      storeMarketplaceForeground: 'base.neutrals.gray800',
      uncheckedForeground: 'base.neutrals.gray500',
      borderStoreSeparator: 'base.neutrals.gray250',
    },
    topbar: {
      background: 'base.neutrals.white',
      borderBg: 'base.neutrals.gray200',
      wishlistIcon: 'base.reds.red500',
    },
    topbarSearch: {
      border: 'base.neutrals.gray250',
      highlight: 'base.neutrals.gray200',
      suggestionsBg: 'base.neutrals.white',
      suggestionsBorder: 'base.neutrals.gray300',
    },
    userProfile: {
      bg: 'base.neutrals.white',
      border: 'base.neutrals.gray250',
      mainInfoBg: 'base.blues.blue500',
      statsForeground: 'base.blues.blue500',
    },
    wishlist: {
      dividerBg: 'base.neutrals.gray300',
      introBg: 'base.blues.blue500',
      introForeground: 'base.neutrals.white',
    },
    lastComments: {
      iconColor: 'base.neutrals.gray900',
      listItemBoxBg: 'base.neutrals.gray200',
      listItemImageBg: 'base.neutrals.gray200',
      listItemImageBorder: 'base.neutrals.gray300',
      listItemImageIconColor: 'base.neutrals.gray300',
      listItemBorder: 'base.neutrals.gray200',
    },
    topContributorsRanking: {
      icon: 'base.yellows.yellow500',
      topUserBg: 'base.yellows.yellow500',
      topUserDetailsBg: 'base.yellows.yellow200',
      userBg: 'base.neutrals.gray250',
      userDetailsBg: 'base.neutrals.gray200',
      userNameForeground: 'base.neutrals.gray800',
      userIndexForeground: 'base.neutrals.gray800',
    },
    threadsListItem: {
      border: 'base.neutrals.gray200',
      icon: 'base.neutrals.gray900',
    },
    thread: {
      borderTop: 'base.blues.blue500',
      foreground: 'base.neutrals.gray700',
      shareBlockBorderTop: 'base.neutrals.gray250',
      fixedTagBg: 'base.neutrals.gray900',
      fixedTagForeground: 'base.neutrals.white',
    },
    threadHead: {
      borderColor: 'base.neutrals.gray200',
    },
    border: 'base.neutrals.gray200',
    warn: 'base.yellows.yellow100',
    white: 'base.neutrals.white',
    searchQuerySuggestedCorrectionTooltip: {
      bg: 'base.greens.green500',
      foreground: 'base.neutrals.white',
    },
    webpushOptIn: {
      foreground: 'base.neutrals.gray750',
    },
  },
};

export default light;
